<div
    [agprLoading]="loading"
    class="agpr-forgotPassword-container"
>
    <div
        class="agpr-forgotPassword-header-container {{ reseller }}"
    >
        <div class="agpr-forgotPassword-header-logo-container" *ngIf="logoUrl">
            <div class="agpr-forgotPassword-header-logoContainer" *ngIf="!logoRouterLink">
                <img
                    [src]="logoUrl"
                    [alt]="logoAltText | localize"
                    class="agpr-forgotPassword-header-logo"
                />
            </div>
            <a class="agpr-forgotPassword-header-logoContainer" *ngIf="logoRouterLink" [href]="logoRouterLink">
                <img
                    [src]="logoUrl"
                    [alt]="logoAltText | localize"
                    class="agpr-forgotPassword-header-logo"
                />
            </a>
        </div>
    </div>

    <div class="agpr-forgotPassword-body-container">
        <div class="agpr-forgotPassword-body-content">
            <h1 class="agpr-headerH1-darkSmaller">{{'PasswordReset.header' | localize}}</h1>

            <div *ngIf="!justSentPasswordReset" class="agpr-forgotPassword-body-inputs">
                <agpr-text-input
                    [formControl]="usernameFormControl"
                    [id]="'forgotPassword_password_input'"
                    type="email"
                    [initialFocus]="true"
                    label="PasswordReset.username"
                    [required]="true"
                    ariaDescribedBy="username_error"
                    [ariaInvalid]="!!usernameFormControl.errors"
                    [bottomMargin]="false"
                >
                </agpr-text-input>
                <agpr-form-message
                    *ngIf="usernameFormControl.dirty && usernameFormControl.errors?.['invalidEmailFormat']"
                    id="username_error"
                >
                    {{ 'PasswordReset.invalidEmail' | localize }}
                </agpr-form-message>
            </div>
            <div *ngIf="justSentPasswordReset">
                {{'PasswordReset.resetEmailSent' | localize}}
            </div>
            <div class="agpr-forgotPassword-body-button">
                <agpr-button
                    id="forgotPassword.back.button"
                    label="PasswordReset.backToLogin"
                    [style]="buttonStyles.secondary"
                    (click)="backToLogin()"
                ></agpr-button>
                <agpr-button
                    *ngIf="!justSentPasswordReset"
                    id="forgotPassword.reset.button"
                    label="PasswordReset.sendResetEmail"
                    [disabled]="!email || usernameFormControl.errors?.['invalidEmailFormat']"
                    (click)="sendResetEmail()"
                    [tooltip]="!email ? 'PasswordReset.noEmail' : (usernameFormControl.errors?.['invalidEmailFormat'] ? 'PasswordReset.invalidEmail' : null)"
                    [style]="buttonTypes.primary"
                >
                </agpr-button>
            </div>
        </div>
    </div>

    <div class="agpr-forgotPassword-copyright-container">
        <div *ngIf="!isResellerDomain" [innerHTML]="'Agility.copyright' | localize"></div>
        <div *ngIf="isResellerDomain">{{'Core.login.reseller.copyright' | localize}}</div>
    </div>
</div>
